import type { GekozenBestand } from "../../contexts/uploadHervatten";

type BestandHandle = {
  kind: "file";
  name: string;
  getFile(): Promise<File>;
};
type MapHandle = {
  kind: "directory";
  name: string;
  values(): AsyncIterable<BestandHandle | MapHandle>;
};

async function lees(
  map: MapHandle,
  basis: string,
  uit: GekozenBestand[],
): Promise<void> {
  for await (const h of map.values()) {
    const pad = `${basis}/${h.name}`;
    if (h.kind === "file")
      uit.push({ relativePath: pad, file: await h.getFile() });
    else await lees(h, pad, uit);
  }
}

/**
 * Laat de gebruiker een map kiezen om een onderbroken upload te hervatten.
 * Chrome en Edge: de mapkiezer van het systeem (File System Access API);
 * anders een verborgen <input webkitdirectory>. Paden beginnen met de mapnaam,
 * net als bij slepen. null = geannuleerd. Direct vanuit een klik aanroepen.
 */
export async function kiesMap(): Promise<GekozenBestand[] | null> {
  const kiezer = (
    window as unknown as { showDirectoryPicker?: () => Promise<MapHandle> }
  ).showDirectoryPicker;
  if (kiezer) {
    try {
      const map = await kiezer.call(window);
      const uit: GekozenBestand[] = [];
      await lees(map, map.name, uit);
      return uit;
    } catch (err) {
      if ((err as { name?: string })?.name === "AbortError") return null;
      throw err;
    }
  }
  return new Promise((resolve) => {
    // Verborgen in de pagina, niet los: Safari vuurt anders niet betrouwbaar
    // change of cancel (L15). Na de keuze gaat hij weer weg.
    const invoer = document.createElement("input");
    invoer.type = "file";
    invoer.setAttribute("webkitdirectory", "");
    invoer.style.display = "none";
    document.body.appendChild(invoer);
    const klaar = (uit: GekozenBestand[] | null) => {
      invoer.remove();
      resolve(uit);
    };
    invoer.addEventListener("change", () => {
      const bestanden = Array.from(invoer.files ?? []);
      klaar(
        bestanden.length
          ? bestanden.map((file) => ({
              relativePath:
                (file as File & { webkitRelativePath?: string })
                  .webkitRelativePath || file.name,
              file,
            }))
          : null,
      );
    });
    invoer.addEventListener("cancel", () => klaar(null));
    invoer.click();
  });
}
